import GameOverPopup from "./GameOverPopup";

import * as PIXI from "pixi.js";
import gsap from "gsap";
import { IGameSnacks } from "../../lib/GameSnacks";
import ServiceLocator from "../../ServiceLocator";
import Utils from "../../Utils";
import Button from "../../lib/Button";
import { Profile } from "../../lib/game_snacks/IUser";
import Session, { game_type } from "../../Session";
import PlayerSlot from "./PlayerSlot";
import LevelUpPopup from "./LevelUpPopup";
import ConfettiAnim from "../ConfettiAnim";
import Player from "../game/Player";
import SpriteMaskAnim from "../../lib/SpriteMaskAnim";

declare global {
    interface Window { GameSnacks: IGameSnacks; }
}


export default class YouWinPopup extends GameOverPopup
{
    // #region Attributes //

    // private:
        
    private _coinBalance: PIXI.Text = null;
    private _baseAnim: PIXI.AnimatedSprite = null;
    private _arrPlayerSlotAnim: Array<PIXI.AnimatedSprite> = null;
    private _winnerFrameAnim: PIXI.AnimatedSprite = null;
    private _rewardValue: PIXI.Text = null;
    private _versusAnim: PIXI.AnimatedSprite = null;
    private _winnerBadge: PIXI.Sprite = null;
    private _rewardWrapper: PIXI.Container = null;
    private _smallCoinIcon: PIXI.Sprite = null;
    private _claimBtn: Button = null;
    private _claimDoubleBtn: Button = null;
    private _levelUpPopup: LevelUpPopup = null;

    private _reward: number = null;

    private _xpBarTl: gsap.core.Timeline = null;
    private _rewardTl: gsap.core.Timeline = null;
    private _rewardUpgradeTween: gsap.core.Tween = null;

    private _confettiAnim: ConfettiAnim = null;

    private _sprayHowl: Howl = null;
    private _barXpUpHowl: Howl = null;

    // #endregion //


    // #region Methods //

    // public:

    public onEnter(): void
    {
        super.onEnter( /*{ bgAlpha: 0.4 }*/ );        

        this._reward = ServiceLocator.resources.game_config.data.rewards.win.coins;

        this._arrPlayerSlotAnim = [];

        let isOffline: boolean = Session.i.gameType == game_type.CLASSIC_OFFLINE
            || Session.i.gameType == game_type.POINTS_OFFLINE;
        let winnerPlayerIndex: number = 0;
        let loserPlayerIndex: number = 1;
        if ( isOffline )
        {
            if ( Session.i.gameType == game_type.CLASSIC_OFFLINE )
            {
                winnerPlayerIndex = this._arrPlayer[ 0 ].score > this._arrPlayer[ 1 ].score ? 0 : 1;
            }
            else if ( Session.i.gameType == game_type.POINTS_OFFLINE )
            {
                winnerPlayerIndex = this._arrPlayer[ 0 ].score == 0 ? 0 : 1;
            }
            loserPlayerIndex = winnerPlayerIndex == 0 ? 1 : 0;
        }
                
        this._backLayer = new PIXI.Container();
        this._root.addChild( this._backLayer );
        //
        this._introLayer = new PIXI.Container();
        this._root.addChild( this._introLayer );
        //        
        this._playerSlotLayer = new PIXI.Container();
        this._playerSlotLayer.visible = false;
        this._root.addChild( this._playerSlotLayer );
        //
        this._introEndLayer = new PIXI.Container();
        this._introEndLayer.visible = false;
        this._root.addChild( this._introEndLayer );

        this._confettiAnim = new ConfettiAnim();
        this._confettiAnim.init();
        this._backLayer.addChild( this._confettiAnim );

        let coinIcon: PIXI.Sprite = new PIXI.Sprite( ServiceLocator.resources.icon_coin.texture );
        coinIcon.visible = Session.i.gameType == game_type.CLASSIC_MATCHMAKING;
        coinIcon.anchor.set( 0.5 );
        coinIcon.position.set( 460, 39 );
        this._root.addChild( coinIcon );

        this._coinBalance = new PIXI.Text( ServiceLocator.saved.data.coins.toString(), {
            fontSize: 60,
            fontFamily: "jaro_regular", 
            fill: 0xffffff
            /*fill: 0x192f62, 
            stroke: 0xffffff, 
            strokeThickness: 4,
            lineJoin: "round"*/
        } );
        this._coinBalance.visible = coinIcon.visible;
        this._coinBalance.anchor.set( 1, 0.5 );
        this._coinBalance.position.set( 612, coinIcon.y );
        this._root.addChild( this._coinBalance );   
        Utils.fitTextToWidth( this._coinBalance, 116 );

        this._bannerWrapper = new PIXI.Container();
        this._bannerWrapper.visible = false;
        this._bannerWrapper.position.set( ServiceLocator.app.width * 0.5, 174 );
        this._introLayer.addChild( this._bannerWrapper );
        //
        let bannerBg: PIXI.Sprite = new PIXI.Sprite( ServiceLocator.resources.win_level_label.texture );
        bannerBg.anchor.set( 0.5 );
        this._bannerWrapper.addChild( bannerBg );
        //
        let bannerMessageTexture: PIXI.Texture = null;
        if ( isOffline )
        {
            bannerMessageTexture = winnerPlayerIndex == 0 ? ServiceLocator.resources.p1_wins.texture : ServiceLocator.resources.p2_wins.texture;
        }
        else
        {
            bannerMessageTexture = ServiceLocator.resources.you_win.texture;
        }
        this._bannerMessage = new PIXI.Sprite( bannerMessageTexture );
        this._bannerMessage.anchor.set( 0.5 );
        this._bannerWrapper.addChild( this._bannerMessage );

        this._bannerMaskIn = new SpriteMaskAnim( Utils.createTexArray( "hud_mask_banner_in_", 7 ) );
        this._bannerMaskIn.fps = 30;
        this._bannerMaskIn.init();
        this._bannerMaskIn.visible = false;
        this._bannerMaskIn.anchor.set( 0.5 );
        this._bannerMaskIn.position.copyFrom( this._bannerWrapper );
        this._introLayer.addChild( this._bannerMaskIn );
        //
        this._bannerWrapper.mask = this._bannerMaskIn;

        this._baseAnim = new PIXI.AnimatedSprite( Utils.createTexArray( "go_vfx_win_base_", 3 ) );
        this._baseAnim.animationSpeed = 10;
        this._baseAnim.loop = false;
        this._baseAnim.autoUpdate = false;
        this._baseAnim.anchor.set( 0.5 );
        this._baseAnim.position.set( 318, 606 );
        this._introLayer.addChild( this._baseAnim );

        this._winnerBadge = new PIXI.Sprite( ServiceLocator.resources.winner_badge.texture );
        this._winnerBadge.visible = false;
        this._winnerBadge.anchor.set( 0.5 );

        let arrScoreText: Array<PIXI.Text> = [];
        for ( let i: number = 0; i < Session.i.kGameRoomSize; ++i )
        {
            let scoreBase: PIXI.Sprite = new PIXI.Sprite( ServiceLocator.resources[ "score_base_" + ( i == winnerPlayerIndex ? "win" : "lose" ) ].texture );
            scoreBase.position.set( this._kArrPlayerSlotPos[ i ].x + ( i == 0 ? -40 : 40 ), this._kArrPlayerSlotPos[ i ].y + 186 );
            this._playerSlotLayer.addChild( scoreBase );     
            //
            let scoreText: PIXI.Text = new PIXI.Text( 
                this._arrPlayer[ i ].score.toString(), 
                { fill: "black", fontSize: 44, fontFamily: "college_tm_regular" } );
            scoreText.position.copyFrom( scoreBase.position );
            scoreText.y += scoreBase.texture.height * 0.5 - 2;
            scoreText.anchor.set( 0.5 );
            this._playerSlotLayer.addChild( scoreText );   
            //
            arrScoreText.push( scoreText );
            
            let playerSlot: PlayerSlot = new PlayerSlot( /*i == 0 ? ServiceLocator.resources.avatar_win_base.texture :*/ ServiceLocator.resources.avatar_lose_base.texture );
            playerSlot.position.copyFrom( this._kArrPlayerSlotPos[ i ] );
            this._playerSlotLayer.addChild( playerSlot );   
            //
            if ( i == 0 )
            {
                scoreText.x += 74;

                if ( isOffline )
                {
                    playerSlot.setPlayer( Session.i.room[ 0 ] );
                }
                else
                {
                    playerSlot.setPlayer( Session.i.profile );
                }
            }
            else
            {
                scoreBase.scale.x = -1;
                scoreText.x -= 74;

                if ( isOffline )
                {
                    playerSlot.setPlayer( Session.i.room[ 1 ] );
                }
                else
                {
                    playerSlot.setPlayer( Session.i.room[ 0 ].uid == Session.i.profile.uid ? Session.i.room[ 1 ] : Session.i.room[ 0 ] );
                }
            }

            if ( i == loserPlayerIndex )
            {
                playerSlot.setPortraitDisabled( true );
            }
            else
            {
                this._winnerBadge.position.set( playerSlot.x - 70, playerSlot.y - 140 );
            }

            let playerSlotAnim: PIXI.AnimatedSprite = new PIXI.AnimatedSprite( Utils.createTexArray( "go_vfx_profile_", 4 ) );
            playerSlotAnim.visible = false;
            playerSlotAnim.scale.x = i == 0 ? 1 : -1;
            playerSlotAnim.animationSpeed = 10;
            playerSlotAnim.loop = false;
            playerSlotAnim.autoUpdate = false;
            playerSlotAnim.anchor.set( 0.5 );
            playerSlotAnim.position.copyFrom( playerSlot.position );
            this._introLayer.addChild( playerSlotAnim );
            //
            this._arrPlayerSlotAnim.push( playerSlotAnim );
        }

        this._winnerFrameAnim = new PIXI.AnimatedSprite( Utils.createTexArray( "go_vfx_win_frame_", 3 ) );
        this._winnerFrameAnim.visible = false;
        this._winnerFrameAnim.animationSpeed = 10;
        this._winnerFrameAnim.loop = false;
        this._winnerFrameAnim.autoUpdate = false;
        this._winnerFrameAnim.anchor.set( 0.5 );
        this._winnerFrameAnim.position.copyFrom( this._arrPlayerSlotAnim[ winnerPlayerIndex ].position );
        this._playerSlotLayer.addChild( this._winnerFrameAnim );

        for ( let scoreText of arrScoreText )
        {
            this._playerSlotLayer.addChild( scoreText );
        }

        this._playerSlotLayer.addChild( this._winnerBadge );

        this._versusAnim = new PIXI.AnimatedSprite( Utils.createTexArray( "go_vfx_versus_", 3 ) );
        this._versusAnim.visible = false;
        this._versusAnim.animationSpeed = 10;
        this._versusAnim.loop = false;
        this._versusAnim.autoUpdate = false;
        this._versusAnim.anchor.set( 0.5 );
        this._versusAnim.position.set( ServiceLocator.app.width * 0.5 + 8, 505 );
        this._playerSlotLayer.addChild( this._versusAnim );

        let xpBarContainer: PIXI.Container = new PIXI.Container();
        xpBarContainer.visible = coinIcon.visible;
        xpBarContainer.position.set( 290, 744 + 20 );
        this._root.addChild( xpBarContainer );
        //
        let xpBarBase: PIXI.Sprite = new PIXI.Sprite( ServiceLocator.resources.level_bar_base.texture );
        xpBarBase.anchor.set( 0.5, 0.5 );
        xpBarContainer.addChild( xpBarBase );
        //
        let xpBar: PIXI.Container = new PIXI.Container();
        xpBarContainer.addChild( xpBar );
        //
        let bar: PIXI.Sprite = new PIXI.Sprite( ServiceLocator.resources.level_bar.texture );
        bar.anchor.set( 0, 0.5 );
        bar.position.set( -bar.width * 0.5, 0 );
        xpBar.addChild( bar );
        //
        let xpBarMask = new PIXI.Graphics();
        xpBarMask.position.set( bar.x, bar.y - bar.height * 0.5 );
        xpBarMask.beginFill( 0xff3300 );
        xpBarMask.drawRect( 0, 0, bar.width, bar.height );
        xpBarMask.endFill();
        const kXpToNextLevel: number = Utils.findXpToNextLevel( ServiceLocator.saved.data.level );
        xpBarMask.scale.x = !Utils.isPlayerMaxLevel() ? Math.min( ServiceLocator.saved.data.xp / kXpToNextLevel, 1 ) : 1;
        xpBar.addChild( xpBarMask );
        xpBar.mask = xpBarMask;
        //
        let xpValue: PIXI.Text = new PIXI.Text( !Utils.isPlayerMaxLevel() ? ServiceLocator.saved.data.xp.toString() + "/" + kXpToNextLevel.toString() : "MAX LEVEL", { fontSize: 34, fontFamily: "college_tm_regular", fill: 0x000000, stroke: 0xffffff, strokeThickness: 4, lineJoin: "round" } );
        xpValue.anchor.set( 0.5 );
        xpValue.y = 2;
        xpBarContainer.addChild( xpValue );

        let levelBase: PIXI.Sprite = new PIXI.Sprite( ServiceLocator.resources.go_level_base.texture );
        levelBase.visible = coinIcon.visible;
        levelBase.anchor.set( 0.5 );
        levelBase.position.set( 473, 745 + 20 )
        this._root.addChild( levelBase );
        //
        let levelValue: PIXI.Text = new PIXI.Text( ServiceLocator.saved.data.level.toString(), { fontSize: 60, fontFamily: "college_tm_regular", fill: 0x192f62, stroke: 0xffffff, strokeThickness: 4, lineJoin: "round" } );
        levelValue.anchor.set( 0.5 );
        levelValue.y = 2;
        levelBase.addChild( levelValue );

        this._rewardWrapper = new PIXI.Container();
        this._rewardWrapper.visible = coinIcon.visible;
        this._root.addChild( this._rewardWrapper );
        //
        let rewardBase: PIXI.Sprite = new PIXI.Sprite( ServiceLocator.resources.reward_label.texture );
        rewardBase.anchor.set( 0.5 );
        rewardBase.position.set( 314, 825 + 20 );
        this._rewardWrapper.addChild( rewardBase );
        //
        let rewardTitle = new PIXI.Text( "Reward:", { fontFamily: "jaro_regular", fontSize: 40, fill: 0xffffff } );
        rewardTitle.anchor.set( 0, 0.5 );
        rewardTitle.position.set( 161, 825 - 4 + 20 );
        this._rewardWrapper.addChild( rewardTitle );
        //
        this._rewardValue = new PIXI.Text( this._reward.toString(), { fontFamily: "jaro_regular", fontSize: 44, fill: 0xffffff } );
        this._rewardValue.anchor.set( 1, 0.5 );
        this._rewardValue.position.set( 473, rewardTitle.y + 2 );
        this._rewardWrapper.addChild( this._rewardValue );
        //
        this._smallCoinIcon = new PIXI.Sprite( ServiceLocator.resources.icon_coin.texture );
        this._smallCoinIcon.anchor.set( 0.5 );
        this._smallCoinIcon.scale.set( 36 / this._smallCoinIcon.texture.width );
        this._smallCoinIcon.position.set( this._rewardValue.x - this._rewardValue.width - 6 - 18, this._rewardValue.y );
        this._rewardWrapper.addChild( this._smallCoinIcon );

        this._claimBtn = new Button( { on: "button_claim", pressed: "button_claim_pressed" } );
        this._claimBtn.visible = false;
        this._claimBtn.anchor.set( 0.5 );
        this._claimBtn.position.set( ServiceLocator.app.width * 0.5, 1009 );
        this._root.addChild( this._claimBtn );
        this._claimBtn.on( "pointertap", this._onClaimBtn_Click.bind( this ) );

        this._footerTitle = new PIXI.Text( "One more game?", { fontFamily: "jaro_regular", fontSize: 40, fill: 0xffffff } );
        this._footerTitle.anchor.set( 0.5 );
        this._footerTitle.position.set( ServiceLocator.app.width * 0.5, 825 - 4 + 30 ); // V2:
        this._introEndLayer.addChild( this._footerTitle );

        this._createNavigationButtons();

        if ( ServiceLocator.saved.data.isFirstGame )
        {
            this._homeBtn.x = ServiceLocator.app.width * 0.5;
            this._retryBtn.visible = false;
            this._footerTitle.visible = false;
        }

        if ( Session.i.gameType == game_type.CLASSIC_MATCHMAKING )
        {
            this._homeBtn.visible = false;
            this._retryBtn.visible = false;

            ServiceLocator.saved.data.score += 1;
            ServiceLocator.saved.save();

            window.GameSnacks.score.update( ServiceLocator.saved.data.score );

            if ( !Utils.isPlayerMaxLevel() )
            {
                this._footerTitle.visible = false;

                this._root.interactiveChildren = false;
                let xp: any = { value: ServiceLocator.saved.data.xp };
                ServiceLocator.saved.data.xp = Math.min( ServiceLocator.saved.data.xp + ServiceLocator.resources.game_config.data.rewards.win.xp, kXpToNextLevel );
                //
                this._xpBarTl = new gsap.core.Timeline();
                const kBarFillDuration: number = ( ServiceLocator.resources.game_config.data.rewards.win.xp / kXpToNextLevel ) * bar.texture.width / 60;
                this._xpBarTl.to( xp, { value: ServiceLocator.saved.data.xp, duration: kBarFillDuration, ease: "linear.inOut", onUpdate: () => { 
                    xpValue.text = Math.floor( xp.value ).toString() + "/" + kXpToNextLevel.toString(); 

                    this._barXpUpHowl = ServiceLocator.audio.playSfx( "bar_xp_up", { restrictRepetition: true, volumeRatio: 0.6 } );
                } }, 0 );
                this._xpBarTl.to( xpBarMask.scale, { x: ServiceLocator.saved.data.xp / kXpToNextLevel, duration: kBarFillDuration, ease: "linear.inOut" }, 0 );
                if ( ServiceLocator.saved.data.xp >= kXpToNextLevel )
                {
                    ServiceLocator.saved.data.xp = 0;//ServiceLocator.saved.data.xp - kXpToNextLevel;
                    ServiceLocator.saved.data.level += 1;

                    let arrShopUnlockedItem: Array<number> = Utils.findShopUnlockedItems( ServiceLocator.saved.data.level );
                    if ( arrShopUnlockedItem[ 0 ] !== null )
                    {
                        ServiceLocator.saved.data.unlockedDarts.push( arrShopUnlockedItem[ 0 ] );
                    }
                    if ( arrShopUnlockedItem[ 1 ] !== null )
                    {
                        ServiceLocator.saved.data.unlockedBoards.push( arrShopUnlockedItem[ 1 ] );
                    }
                    
                    this._xpBarTl.to( levelBase.scale, { x: 1.2, y: 1.2, duration: 0.2, repeat: 1, yoyo: true, ease: "sine.inOut" } );
                    this._xpBarTl.call( () => { 
                        this._barXpUpHowl.stop();
                        this._barXpUpHowl = null;

                        ServiceLocator.audio.playSfx( "bar_level_up", { volumeRatio: 0.6 } );

                        const kXpToNextLevel = Utils.findXpToNextLevel( ServiceLocator.saved.data.level );
                        xpBarMask.scale.x = !Utils.isPlayerMaxLevel() ? kXpToNextLevel / ServiceLocator.saved.data.xp : 1;
                        xpValue.text = !Utils.isPlayerMaxLevel() ? ServiceLocator.saved.data.xp.toString() + "/" + kXpToNextLevel.toString() : "MAX LEVEL";
                        levelValue.text = ServiceLocator.saved.data.level.toString(); }, null, "<" );
                    this._xpBarTl.call( () => { 
                        this._levelUpPopup = new LevelUpPopup();
                        this._levelUpPopup.onEnter(); 
                        this._levelUpPopup.onClosed.add( () => {
                            this._levelUpPopup.onLeave();
                            this._levelUpPopup = null;

                            let dummyReward: any = { x: this._reward };
                            this._reward += ServiceLocator.resources.game_config.data.rewards.levelUp.coins;
                            this._rewardUpgradeTween = gsap.to( dummyReward, { x: this._reward, duration: ServiceLocator.resources.game_config.data.rewards.levelUp.coins / 100, ease: "linear.inOut", 
                                onUpdate: () => { 
                                    this._rewardValue.text = Math.round( dummyReward.x ).toString(); 
                                    this._smallCoinIcon.x = this._rewardValue.x - this._rewardValue.width - 6 - 18;
                                }
                            } );

                            this._coinBalance.text = ServiceLocator.saved.data.coins.toString();
                        } );
                    }, null, "<+1" );
                }
                this._xpBarTl.call( () => { 
                    this._root.interactiveChildren = true;

                    this._claimBtn.visible = true;
                    if ( this._claimDoubleBtn )
                    {
                        this._claimDoubleBtn.visible = true;
                    }
                } );
                this._xpBarTl.pause();
                //
                ServiceLocator.saved.save();
            }
        }

        // Start intro animation.
        this._baseAnim.onComplete = () => {
            for ( let playerSlotAnim of this._arrPlayerSlotAnim )
            {
                playerSlotAnim.visible = true;
                playerSlotAnim.play();
            }
            
            this._sprayHowl.stop();
            this._sprayHowl = ServiceLocator.audio.playSfx( "intro_spray_1", { loop: true } );
        };
        //
        this._arrPlayerSlotAnim[ 1 ].onComplete = () => {
            for ( let playerSlotAnim of this._arrPlayerSlotAnim )
            {
                playerSlotAnim.visible = false;
            }

            this._playerSlotLayer.visible = true;

            this._versusAnim.visible = true;
            this._versusAnim.play();
        };
        //
        this._versusAnim.onComplete = () => {
            this._winnerFrameAnim.visible = true;
            this._winnerFrameAnim.play();
        };
        //
        this._winnerFrameAnim.onComplete = () => {
            this._winnerBadge.visible = true;

            this._bannerWrapper.visible = true;
            this._bannerMaskIn.visible = true;
            
            this._sprayHowl.stop();
            this._sprayHowl = ServiceLocator.audio.playSfx( "intro_spray_2", { loop: true } );
        };
        //
        this._bannerMaskIn.onCompleted.addOnce( () => {
            this._bannerMaskIn.visible = false;

            this._introEndLayer.visible = true;

            if ( this._xpBarTl )
            {
                this._xpBarTl.play();
            }
            
            this._sprayHowl.stop();
            this._sprayHowl = null;

            ServiceLocator.audio.playSfx( "game_over_win" );
        }, this );
        //
        this._baseAnim.play();
        
        this._sprayHowl = ServiceLocator.audio.playSfx( "intro_spray_0", { loop: true } );
        
        if ( Session.i.gameType == game_type.CLASSIC_MATCHMAKING )
        {
            ServiceLocator.game.ad.onAdReady.addOnce( this._onAd_Ready, this );
            ServiceLocator.game.ad.onAdLost.add( this._onAd_Lost, this );
            ServiceLocator.game.ad.onAdCompleted.add( this._onAd_Completed, this );
            //
            ServiceLocator.game.ad.prepare();
        }
    }

        private _onClaimBtn_Click(): void
        {
            this._playRewardAnim( ServiceLocator.saved.data.coins, this._reward );

            ServiceLocator.saved.data.coins += this._reward;
            ServiceLocator.saved.save();

            this._claimBtn.visible = false;
            if ( this._claimDoubleBtn )
            {
                this._claimDoubleBtn.visible = false;
            }
        }

            private _playRewardAnim( coinBalance: number, reward: number ): void
            {
                this._rewardTl = new gsap.core.Timeline();
                for ( let i: number = 0; i < 10; ++i )
                {
                    let coin: PIXI.Sprite = new PIXI.Sprite( this._smallCoinIcon.texture );
                    coin.anchor.set( 0.5 );
                    coin.scale.copyFrom( this._smallCoinIcon.scale );
                    coin.position.copyFrom( this._smallCoinIcon );
                    this._root.addChild( coin );
                    //
                    this._rewardTl.to( coin, { x: 460, y: 39, duration: 0.2, ease: "sine.out", onComplete: () => { 
                        ServiceLocator.audio.playSfx( "coin"/*, { restrictRepetition: true }*/ );

                        this._root.removeChild( coin ); 
                    } }, i * 0.1 );
                }
                let coins: any = { value: coinBalance };
                this._rewardTl.to( coins, { value: coins.value + reward, duration: 1, ease: "linear.inOut", onUpdate: () => { this._coinBalance.text = Math.floor( coins.value ).toString(); } }, 0.2 );
                this._rewardTl.call( () => {
                    this._rewardWrapper.visible = false;
                    
                    this._homeBtn.visible = true;
                    this._retryBtn.visible = !ServiceLocator.saved.data.isFirstGame;
                    this._footerTitle.visible = !ServiceLocator.saved.data.isFirstGame;
                } );
            }

        private _onClaimDoubleBtn_Click(): void
        {
            ServiceLocator.game.ad.watch( this._reward );
        }

        private _onAd_Ready(): void
        {
            this._claimDoubleBtn = new Button( { on: "button_claim_x2", pressed: "button_claim_x2_pressed" } );
            this._claimDoubleBtn.visible = this._root.interactiveChildren;
            this._claimDoubleBtn.anchor.set( 0.5 );
            this._claimDoubleBtn.position.set( 175, 1015 );
            this._root.addChild( this._claimDoubleBtn );
            this._claimDoubleBtn.on( "pointertap", this._onClaimDoubleBtn_Click.bind( this ) );
        
            this._claimBtn.x = 458;
            this._claimBtn.visible = this._root.interactiveChildren;
        }

        private _onAd_Lost(): void
        {
            this._claimBtn.visible = this._root.interactiveChildren;
                        
            if ( ServiceLocator.game.ad.isShowingAd )
            {
                this._claimBtn.x = ServiceLocator.app.width * 0.5;
                this._claimDoubleBtn.visible = false;
            }
        }

        private _onAd_Completed(): void
        {
            /*let tl: gsap.core.Timeline = new gsap.core.Timeline();
            tl.to( this._rewardValue.scale, { y: 0, duration: 0.24, ease: "back.in" } );
            tl.call( () => {
                this._rewardValue.text = this._reward * 2;
            }, null, );
            tl.to( this._rewardValue.scale, { y: 1, duration: 0.24, ease: "back.out" } );
            tl.call( () => { this._playRewardAnim( this._reward * 2 ); } );
            ServiceLocator.game.tweenGroup.add( tl );*/

            const kCoinBalance: number = ServiceLocator.saved.data.coins;
            let dummyReward: any = { x: this._reward };
            this._reward *= 2;
            this._rewardUpgradeTween = gsap.to( dummyReward, { x: this._reward, duration: ServiceLocator.resources.game_config.data.rewards.levelUp.coins / 100, ease: "linear.inOut", 
                onUpdate: () => { 
                    this._rewardValue.text = Math.round( dummyReward.x ).toString(); 
                    this._smallCoinIcon.x = this._rewardValue.x - this._rewardValue.width - 6 - 18;
                },
                onComplete: () => { this._playRewardAnim( kCoinBalance, this._reward ); }
            } );
            
            ServiceLocator.saved.data.coins += this._reward;
            ServiceLocator.saved.save();

            this._claimBtn.visible = false;
            this._claimDoubleBtn.visible = false;
        }

    public onLeave(): void
    {
        this._confettiAnim.end();
        this._confettiAnim = null;

        if ( this._xpBarTl )
        {
            this._xpBarTl.kill();
            this._xpBarTl = null;
        }
        
        if ( this._rewardTl )
        {
            this._rewardTl.kill();
            this._rewardTl = null;

            ServiceLocator.game.ad.onAdReady.remove( this._onAd_Ready, this );
            ServiceLocator.game.ad.onAdLost.remove( this._onAd_Lost, this );
            ServiceLocator.game.ad.onAdCompleted.remove( this._onAd_Completed, this );
        }

        if ( this._rewardUpgradeTween )
        {
            this._rewardUpgradeTween.kill();
            this._rewardUpgradeTween = null;
        }
        
        if ( this._sprayHowl )
        {
            this._sprayHowl.stop();
            this._sprayHowl = null;
        }

        this._bannerMaskIn.end();
        this._bannerMaskIn = null;

        super.onLeave();
    }

    public onUpdate( dt: number ): void
    {
        this._confettiAnim.update( dt );
        
        if ( this._baseAnim.visible )
        {
            this._baseAnim.update( dt );
        }
        if ( this._bannerMaskIn.visible )
        {
            this._bannerMaskIn.update( dt );
        }
        for ( let playerSlotAnim of this._arrPlayerSlotAnim )
        {
            if ( playerSlotAnim.visible )
            {
                playerSlotAnim.update( dt );
            }
        }
        if ( this._versusAnim.visible )
        {
            this._versusAnim.update( dt );
        }
        if ( this._winnerFrameAnim.visible )
        {
            this._winnerFrameAnim.update( dt );
        }
        if ( this._levelUpPopup )
        {
            this._levelUpPopup.onUpdate( dt );
        }

        super.onUpdate( dt );
    }

    // #endregion //
}